import React from "react";
import { Link } from "react-router-dom";

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gray-50 px-4 py-10">
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <div className="flex items-center justify-between mb-4">
          <h1 className="text-2xl font-bold text-gray-900">Terms of Service</h1>
          <Link to="/" className="text-sm text-indigo-600 hover:text-indigo-700">
            Back to Home
          </Link>
        </div>
        <p className="text-sm text-gray-600 leading-relaxed">
          By using Songzug, you agree to follow our terms of service. Please read these
          terms carefully before using the platform.
        </p>
        <div className="mt-4 space-y-3 text-sm text-gray-600">
          <p><strong>Acceptable Use:</strong> Do not post illegal or harmful content.</p>
          <p><strong>Account Responsibility:</strong> You are responsible for your account security.</p>
          <p><strong>Service Changes:</strong> We may update or modify services at any time.</p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
